import React, { useRef } from 'react';
import { FcSurvey } from "react-icons/fc";
import { useDispatch } from "react-redux";
import { EditSurveyHeaderBackground, EditSurveyFooterBackground } from "../../../redux/slice/SurveySlice/SurveySlice";
import ImageUpload from '../../Image/ImageUpload';
export default function SurveyHeader({
  preview,
  title,
  description,
  headerBackgroundPath,
  footerBackgroundPath,
  OnChangeTitle,
  OnChangeDescription,
}) {
  const dispatch = useDispatch();

const handleHeaderFileChange = (e) => {
  const fileInput = fileInputRef.current; // Dosya input referansı
  const file = e.target.files[0];

  // Dosya kontrolü: Yalnızca jpg, jpeg, png
  const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  if (file && !validTypes.includes(file.type)) {
    alert('Lütfen sadece JPG, JPEG veya PNG dosyası yükleyin.');
    
    // Dosya input'unu sıfırlama (geçersiz dosya seçildiğinde)
    fileInput.value = '';
    return;
  }

  // Dosya boyutu kontrolü: 50MB
  const maxSize = 50 * 1024 * 1024; // 50MB
  if (file && file.size > maxSize) {
    alert('Dosya boyutu 50MB\'yi geçemez.');
    
    // Dosya input'unu sıfırlama (dosya boyutu geçerse)
    fileInput.value = '';
    return;
  }

  // Eğer tüm kontrolleri geçerse dosyayı işleme al
  if (file) {
    dispatch(EditSurveyHeaderBackground(file));
    console.log(file);
  }
};

const handleFooterFileChange = (e) => {
  const fileInput = fileInputRef.current; // Dosya input referansı
  const file = e.target.files[0];

  // Dosya kontrolü: Yalnızca jpg, jpeg, png
  const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  if (file && !validTypes.includes(file.type)) {
    alert('Lütfen sadece JPG, JPEG veya PNG dosyası yükleyin.');
    
    // Dosya input'unu sıfırlama (geçersiz dosya seçildiğinde)
    fileInput.value = '';
    return;
  }

  // Dosya boyutu kontrolü: 50MB
  const maxSize = 50 * 1024 * 1024; // 50MB
  if (file && file.size > maxSize) {
    alert('Dosya boyutu 50MB\'yi geçemez.');
    
    // Dosya input'unu sıfırlama (dosya boyutu geçerse)
    fileInput.value = '';
    return;
  }

  // Eğer tüm kontrolleri geçerse dosyayı işleme al
  if (file) {
    dispatch(EditSurveyFooterBackground(file));
    console.log(file);
  }
};
  

const fileInputRef = useRef(null);
  return (
    <>
    <div className="lg:w-[1100px] md:w-full bg-white my-4 p-2 flex rounded-lg">
      <div className="flex justify-center items-center text-center m-8">
        <FcSurvey size={100} />
      </div>
      <div className="w-full pr-4 py-4">
        {/* Survey Title Section */}
        <div className="relative z-0 mb-6 w-full group">
          <input
            value={title}
            maxLength={250}
            className="block py-2.5 px-0 w-full text-3xl text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required
            onChange={(e) => OnChangeTitle(e.target.value)}
          />
          <label className="peer-focus:font-medium absolute text-xl text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
            Anket Başlığı
          </label>
        </div>
  
        {/* Survey Description Section */}
        <div className="relative z-0 mb-6 w-full group">
          <input
            className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            value={description}
            maxLength={1000}
            onChange={(e) => OnChangeDescription(e.target.value)}
          />
          <label className="peer-focus:font-semibold absolute text-lg text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
            Anket Açıklaması (Zorunlu Değildir)
          </label>
        </div>
  
        <ImageUpload
          headerBackgroundPath={headerBackgroundPath} 
          footerBackgroundPath={footerBackgroundPath}
        />

        {/* <div className="relative z-0 mb-8 w-full group">
          <label className="block text-sm text-gray-500 mb-2">
            Anket Alt Resim (Zorunlu Değildir)
          </label>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            className="block w-full px-4 py-3 text-sm text-gray-700 bg-white border-2 border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100"
            onChange={(e) => handleFooterFileChange(e)}
          />
        </div> */}

      </div>
    </div>
  </>  
  );
}
